export default "__VITE_ASSET__a704db54__"